/* Petwizo CRO kit — comportements. Vanilla JS, aucune dépendance. */
(function () {
  'use strict';

  /* ---------- Sticky Add to Cart : visible quand le vrai bouton sort du viewport ---------- */
  function initStickyATC() {
    var bar = document.querySelector('.pz-sticky-atc');
    if (!bar) return;
    var realForm = document.querySelector('product-form form, form[action$="/cart/add"]');
    var realBtn = realForm ? realForm.querySelector('[type="submit"]') : null;

    // Le bouton sticky soumet le vrai formulaire produit (respecte la variante sélectionnée).
    var stickyBtn = bar.querySelector('.pz-sticky-atc__btn');
    if (stickyBtn && realForm) {
      stickyBtn.addEventListener('click', function () {
        if (realBtn) { realBtn.click(); }
        else { realForm.requestSubmit ? realForm.requestSubmit() : realForm.submit(); }
      });
    }

    var anchor = realBtn || realForm;
    if (!anchor || !('IntersectionObserver' in window)) {
      bar.classList.add('pz-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      // Affiche la barre quand le bouton d'origine n'est PAS visible.
      bar.classList.toggle('pz-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Countdown "Order in Xh Ym → ships today" ----------
     Logique : on vise une heure de cut-off (ex. 16h heure US Est).
     Avant le cut-off, on décompte jusqu'au cut-off du jour.
     Après, on décompte jusqu'au cut-off du lendemain. */
  function initCountdown() {
    var el = document.querySelector('.pz-countdown');
    if (!el) return;
    var timeEl = el.querySelector('.pz-countdown__time');
    var labelEl = el.querySelector('.pz-countdown__label');
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour') || '16', 10);

    function nextCutoff() {
      var now = new Date();
      var c = new Date(now);
      c.setHours(cutoffHour, 0, 0, 0);
      if (now >= c) { c.setDate(c.getDate() + 1); }
      return c;
    }

    function tick() {
      var now = new Date();
      var target = nextCutoff();
      var diff = Math.max(0, target - now);
      var beforeCutoffToday = now.getHours() < cutoffHour;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (timeEl) {
        timeEl.textContent =
          String(h).padStart(2, '0') + 'h ' +
          String(m).padStart(2, '0') + 'm ' +
          String(s).padStart(2, '0') + 's';
      }
      if (labelEl) {
        labelEl.textContent = beforeCutoffToday
          ? 'Order within and it ships TODAY'
          : 'Order within to ship tomorrow';
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Bundle / quantity breaks ---------- */
  function initBundle() {
    var bundle = document.querySelector('.pz-bundle');
    if (!bundle) return;
    var qtyInput = document.querySelector('input[name="quantity"]');
    var opts = bundle.querySelectorAll('.pz-bundle__opt');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('pz-selected'); });
        opt.classList.add('pz-selected');
        var qty = opt.getAttribute('data-qty');
        if (qtyInput && qty) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function init() {
    initStickyATC();
    initCountdown();
    initBundle();
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
